import { CorrespondanceAttachment } from "./CorrespondanceAttachment.model";
import { PostModel } from "./post.model";
import { DpoPostType } from "./postType.model";

export class CorrespondanceModel{
    dpoId: string;
    dpoActionId: string;
    dpoSmsBodyId: string;
    dpoPostTypeId: string;
    dpoPostTypeName: string;
    post: PostModel;
    dpoPostType: DpoPostType;
    correspondanceAttachments: CorrespondanceAttachment[]=[];
}